import { Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

type Props = {
  date: string
  color: string
  fontFamily: string
}

type TimeLeft = {
  years?: number
  days: number
  hours: number
  min: number
  sec: number
}

const addLeadingZeros = (value: number): string => value.toString().padStart(2, '0')

const Countdown = (props: Props) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    min: 0,
    sec: 0,
  })

  useEffect(() => {
    const calculateCountdown = (endDate: string): TimeLeft | false => {
      let diff = (Date.parse(endDate) - Date.now()) / 1000
      if (diff <= 0) return false

      const time: TimeLeft = {
        days: 0,
        hours: 0,
        min: 0,
        sec: 0,
      }

      if (diff >= 86_400) {
        time.days = Math.floor(diff / 86_400)
        diff -= time.days * 86_400
      }
      if (diff >= 3600) {
        time.hours = Math.floor(diff / 3600)
        diff -= time.hours * 3600
      }
      if (diff >= 60) {
        time.min = Math.floor(diff / 60)
        diff -= time.min * 60
      }
      time.sec = Math.floor(diff)

      return time
    }

    const interval = setInterval(() => {
      const updatedTime = calculateCountdown(props.date)
      if (updatedTime) {
        setTimeLeft(updatedTime)
      } else {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [props.date])

  return (
    <Stack alignItems='center' direction='row' justifyContent='center' width={1}>
      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          <strong>{addLeadingZeros(timeLeft.days)}</strong>
          <span>{' days '}</span>
        </span>
      </Typography>

      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        paddingLeft={1}
        sx={{
          width: '40px',
        }}
        textAlign='center'
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          <strong>{addLeadingZeros(timeLeft.hours)}</strong>
        </span>
      </Typography>

      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        sx={{
          width: '12px',
        }}
        textAlign='center'
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          :
        </span>
      </Typography>

      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        sx={{
          width: '40px',
        }}
        textAlign='center'
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          <strong>{addLeadingZeros(timeLeft.min)}</strong>
        </span>
      </Typography>

      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        sx={{
          width: '12px',
        }}
        textAlign='center'
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          :
        </span>
      </Typography>

      <Typography
        color={props.color}
        fontFamily={props.fontFamily}
        fontSize='1.2em'
        lineHeight={1.1}
        sx={{
          width: '40px',
        }}
        textAlign='center'
        variant='helperText'
      >
        <span className='Countdown-col-element'>
          <strong>{addLeadingZeros(timeLeft.sec)}</strong>
        </span>
      </Typography>
    </Stack>
  )
}

export default Countdown
